import { ContainerPrivacyPolicy } from "./styled";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import {
  fetchData,
  selectIsLoading} from "../../../../mainApp/features/DataSlice/dataSlice";
  import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";
import LoadingPage from "../LoadingPage";
import ErrorPage from "../ErrorPage";

const AIButton = styled(NavLink)`
  display: inline-block;
  background-color: ${({ theme }) => theme.color.spotifyDarkGreen || "#1DB954"};
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 20px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyBrightGreen || "#17a34a"};
  }
`;

const PrivacySection = styled.div`
  margin-bottom: 30px;
  
  h2 {
    color: ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
    border-bottom: 2px solid ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  
  h3 {
    color: ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
    margin-top: 25px;
    margin-bottom: 15px;
  }
  
  ol, ul {
    margin-left: 20px;
    margin-bottom: 15px;
  }
  
  li {
    margin-bottom: 8px;
    line-height: 1.6;
  }
  
  strong {
    color: ${({ theme }) => theme.color.dragonOrange || "#FF6B35"};
  }
  
  .important {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
  }
  
  .contact-info {
    background-color: #e8f5e8;
    border: 1px solid #c3e6c3;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
  }
  
  .cookie-info {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 15px;
    margin: 15px 0;
  }
  
`;

function PrivacyPolicy() {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const location = useLocation();
  const [backButtonConfig, setBackButtonConfig] = useState({
    text: "Wróć do ustawień",
    path: "/settings/policy"
  });

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  let returned = "";

  switch (isLoading) {
    case "loading":
      returned = <LoadingPage />;
      break;
    case "success":
      returned = (
        <ContainerPrivacyPolicy>
          <AIButton to={"/settings/policy"}>Powrót</AIButton>
          <h1 className="h1 text-center">Polityka Prywatności i Plików Cookies Aplikacji DragonscapeAI</h1>
          <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '30px' }}>
            obowiązuje od dnia 28.08.2025 r.
          </p>
          
          <PrivacySection>
            <p>
              Twoja prywatność jest dla nas priorytetem. W tym dokumencie wyjaśniamy, jakie dane zbieramy, w jakim celu to robimy i jakie masz w związku z tym prawa. Korzystając z aplikacji DragonscapeAI (dalej „Aplikacja"), akceptujesz zasady opisane poniżej.
            </p>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 1. Kto jest administratorem Twoich danych?</h2>
            <p>
              Administratorem Twoich danych osobowych (dalej „Administrator") jest <strong>Nowakowski Solutions - Miłosz Nowakowski</strong>, prowadzący działalność gospodarczą z siedzibą w Polsce, NIP: 5992652322, REGON: 080081269.
            </p>
            <p>
              W sprawach związanych z ochroną danych osobowych możesz skontaktować się z nami pod adresem e-mail: <strong>kontakt@dragonscape.pl</strong>
            </p>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 2. Jakie dane o Tobie zbieramy i dlaczego?</h2>
            <p>Przetwarzamy Twoje dane w różnych celach, w zależności od tego, w jaki sposób korzystasz z naszej Aplikacji.</p>
            
            <h3>Rejestracja i zarządzanie Kontem:</h3>
            <ul>
              <li><strong>Dane:</strong> Imię, nazwisko, adres e-mail, opcjonalnie zdjęcie profilowe.</li>
              <li><strong>Cel:</strong> Utworzenie i prowadzenie Twojego indywidualnego Konta, umożliwienie logowania i personalizacji profilu.</li>
              <li><strong>Podstawa prawna:</strong> Niezbędność do wykonania umowy o świadczenie usług (art. 6 ust. 1 lit. b RODO).</li>
            </ul>

            <h3>Obsługa płatnych subskrypcji:</h3>
            <ul>
              <li><strong>Dane:</strong> Dane korespondencyjne, dane do faktury (w tym NIP), historia płatności. Dane karty płatniczej nie są przez nas przechowywane – są przetwarzane bezpośrednio przez operatora płatności.</li>
              <li><strong>Cel:</strong> Realizacja i rozliczanie płatnych subskrypcji.</li>
              <li><strong>Podstawa prawna:</strong> Niezbędność do wykonania umowy oraz wypełnienie obowiązków prawnych (np. podatkowych i księgowych) (art. 6 ust. 1 lit. b i c RODO).</li>
            </ul>

            <h3>Świadczenie usług generowania treści przez AI:</h3>
            <ul>
              <li><strong>Dane:</strong> Treści zapytań (promptów) wprowadzane przez Ciebie.</li>
              <li className="important">
                <strong>WAŻNE:</strong> Nie wprowadzaj w promptach żadnych danych osobowych, w tym danych wrażliwych.
              </li>
              <li><strong>Cel:</strong> Przesłanie Twojego zapytania do zewnętrznych dostawców API (OpenAI, getimg API, Suno API, PiAPI) w celu wygenerowania treści.</li>
              <li><strong>Podstawa prawna:</strong> Niezbędność do wykonania umowy (art. 6 ust. 1 lit. b RODO).</li>
            </ul>

            <h3>Analiza i rozwój Aplikacji:</h3>
            <ul>
              <li><strong>Dane:</strong> Dane analityczne, takie jak identyfikatory urządzeń, informacje o interakcjach z Aplikacją (np. używane funkcje, czas spędzony w Aplikacji), zanonimizowany adres IP.</li>
              <li><strong>Cel:</strong> Zrozumienie, jak Użytkownicy korzystają z Aplikacji, diagnozowanie problemów technicznych i ulepszanie naszych usług.</li>
              <li><strong>Podstawa prawna:</strong> Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO), polegający na optymalizacji Aplikacji.</li>
            </ul>

            <h3>Komunikacja i wsparcie (czat na żywo):</h3>
            <ul>
              <li><strong>Dane:</strong> Identyfikatory sesji czatu, treść rozmowy, adres e-mail (jeśli go podasz).</li>
              <li><strong>Cel:</strong> Udzielanie wsparcia technicznego i odpowiadanie na Twoje pytania.</li>
              <li><strong>Podstawa prawna:</strong> Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO), polegający na zapewnieniu wysokiej jakości obsługi klienta.</li>
            </ul>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 3. Kto jest odbiorcą Twoich danych?</h2>
            <p>Twoje dane udostępniamy tylko zaufanym partnerom, którzy pomagają nam świadczyć usługi. Zawarliśmy z nimi odpowiednie umowy powierzenia przetwarzania danych.</p>
            
            <ul>
              <li><strong>Google (Firebase):</strong> Dostawca infrastruktury chmurowej, na której przechowujemy Twoje dane (dane konta, zdjęcie profilowe, dane pobrane ze Stripe). Dane są szyfrowane zarówno podczas przesyłania, jak i w spoczynku.</li>
              <li><strong>Netlify, Inc.:</strong> Dostawca usług hostingowych, na których działa nasza Aplikacja.</li>
              <li><strong>Stripe, Inc.:</strong> Operator płatności, który bezpiecznie przetwarza Twoje dane płatnicze i korespondencyjne w celu realizacji subskrypcji.</li>
              <li><strong>Google Analytics:</strong> Narzędzie do analizy ruchu w Aplikacji, które pomaga nam zrozumieć zachowania użytkowników.</li>
              <li><strong>Crisp IM SARL:</strong> Dostawca czatu na żywo, umożliwiający nam komunikację z Tobą.</li>
              <li><strong>Dostawcy API AI (OpenAI, getimg, Suno, PiAPI):</strong> Podmioty, do których przekazywane są Twoje zapytania (prompty) w celu wygenerowania treści. Nie przekazujemy im żadnych danych identyfikujących Cię.</li>
              <li><strong>Upoważnione organy publiczne:</strong> W przypadkach wymaganych przez prawo (np. na żądanie sądu lub prokuratury).</li>
            </ul>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 4. Transfer danych poza Europejski Obszar Gospodarczy (EOG)</h2>
            <p>
              Korzystamy z usług dostawców (m.in. Google, Netlify, Stripe, OpenAI), których serwery mogą znajdować się poza EOG, głównie w USA. W takich przypadkach transfer danych odbywa się na podstawie Standardowych Klauzul Umownych zatwierdzonych przez Komisję Europejską, co zapewnia odpowiedni poziom ochrony Twoich danych, zgodny z RODO.
            </p>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 5. Jak długo przechowujemy Twoje dane?</h2>
            <ul>
              <li><strong>Dane Twojego Konta</strong> przechowujemy przez cały okres posiadania Konta w Aplikacji, aż do jego usunięcia.</li>
              <li><strong>Dane związane z płatnościami</strong> przechowujemy przez okres wymagany przepisami prawa podatkowego (zazwyczaj 5 lat od końca roku kalendarzowego, w którym dokonano płatności).</li>
              <li><strong>Dane analityczne i dane z czatu</strong> przechowujemy przez okres niezbędny do realizacji celów, w jakich zostały zebrane, jednak nie dłużej niż 26 miesięcy.</li>
            </ul>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 6. Twoje prawa związane z RODO</h2>
            <p>Masz prawo do:</p>
            <ul>
              <li><strong>Dostępu do swoich danych</strong> – możesz poprosić o kopię danych, które posiadamy.</li>
              <li><strong>Sprostowania danych</strong> – jeśli uważasz, że Twoje dane są nieprawidłowe lub niekompletne.</li>
              <li><strong>Usunięcia danych („prawo do bycia zapomnianym")</strong> – możesz zażądać usunięcia danych, jeśli nie są już niezbędne do celów, w których zostały zebrane.</li>
              <li><strong>Ograniczenia przetwarzania</strong> – w określonych przypadkach możesz zażądać, abyśmy ograniczyli przetwarzanie Twoich danych.</li>
              <li><strong>Przenoszenia danych</strong> – masz prawo otrzymać swoje dane w ustrukturyzowanym, powszechnie używanym formacie.</li>
              <li><strong>Wniesienia sprzeciwu</strong> – wobec przetwarzania danych na podstawie naszego prawnie uzasadnionego interesu.</li>
              <li><strong>Wycofania zgody</strong> – w dowolnym momencie, jeśli przetwarzanie odbywa się na podstawie zgody (nie wpływa to na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem).</li>
              <li><strong>Wniesienia skargi do organu nadzorczego</strong> – jeśli uważasz, że przetwarzamy Twoje dane niezgodnie z prawem. W Polsce jest to Prezes Urzędu Ochrony Danych Osobowych (UODO).</li>
            </ul>
            <p>Aby skorzystać ze swoich praw, skontaktuj się z nami pod adresem e-mail podanym w § 1.</p>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 7. Polityka Plików Cookies</h2>
            <p>Pliki cookies to małe pliki tekstowe zapisywane na Twoim urządzeniu. Używamy ich, aby zapewnić prawidłowe działanie Aplikacji, analizować ruch i oferować lepsze usługi.</p>
            
            <h3>A. Cookies własne (niezbędne):</h3>
            <div className="cookie-info">
              <p><strong>Nazwa:</strong>np. myAwesomeCookieName2</p>
              <p><strong>Cel:</strong> Zapisywanie Twoich podstawowych ustawień i preferencji w Aplikacji (np. język, ustawienia interfejsu). Są one kluczowe dla prawidłowego działania Aplikacji.</p>
              <p><strong>Podstawa prawna:</strong> Niezbędność do świadczenia usługi (art. 173 ust. 3 Prawa Telekomunikacyjnego).</p>
            </div>

            <h3>B. Cookies podmiotów trzecich (analityczne i funkcjonalne):</h3>
            <p>Używamy ich tylko po uzyskaniu Twojej wyraźnej zgody.</p>
            
            <div className="cookie-info">
              <h4>Google Analytics:</h4>
              <ul>
                <li><strong>Cookies:</strong> _ga_6428N3HQ9E i inne z rodziny _ga.</li>
                <li><strong>Cel:</strong> Tworzenie anonimowych statystyk dotyczących korzystania z Aplikacji, co pomaga nam ją ulepszać.</li>
                <li><strong>Więcej informacji:</strong> Polityka Prywatności Google</li>
              </ul>
            </div>

            <div className="cookie-info">
              <h4>Crisp Chat:</h4>
              <ul>
                <li><strong>Cookies:</strong> crisp-client/*, crisp-market/*, AMP_* i inne.</li>
                <li><strong>Cel:</strong> Umożliwienie działania czatu na żywo, zapamiętanie historii rozmowy i identyfikacja sesji w celu zapewnienia ciągłości wsparcia.</li>
                <li><strong>Więcej informacji:</strong> Polityka Prywatności Crisp</li>
              </ul>
            </div>

            <div className="cookie-info">
              <h4>Stripe:</h4>
              <ul>
                <li><strong>Cel:</strong> Zapewnienie bezpieczeństwa transakcji, wykrywanie oszustw i prawidłowe funkcjonowanie formularzy płatniczych.</li>
                <li><strong>Więcej informacji:</strong> Polityka Cookies Stripe</li>
              </ul>
            </div>

            <h3>C. Zarządzanie plikami cookies:</h3>
            <p>Możesz zarządzać swoimi zgodami na pliki cookies za pośrednictwem banera cookies dostępnego w Aplikacji. Możesz również zmienić ustawienia w swojej przeglądarce, aby blokować lub usuwać pliki cookies, jednak może to wpłynąć na działanie niektórych funkcji naszej Aplikacji.</p>
          </PrivacySection>

          <PrivacySection>
            <h2>§ 8. Zmiany w Polityce Prywatności</h2>
            <p>
              Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. O wszelkich zmianach poinformujemy Cię z odpowiednim wyprzedzeniem poprzez komunikat w Aplikacji lub wiadomość e-mail. Nowa wersja polityki będzie obowiązywać od daty wskazanej na jej początku.
            </p>
          </PrivacySection>
        </ContainerPrivacyPolicy>
      );
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
};

export default PrivacyPolicy;